export default class DtoAccountStatistic {
    constructor(obj) {
        this.id = obj.id
        this.login = obj.login
        this.statisticDate = obj.statisticDate
        this.eventType = obj.eventType
        this.module = obj.module
        this.value = obj.value
    }
}